import { Toaster } from 'sonner';
import useLenis from '@/lib/useLenis';
import useReveal from '@/lib/useReveal';
import Nav from '@/components/landing/Nav';
import Hero from '@/components/landing/Hero';
import PodBristol from '@/components/landing/PodBristol';
import About from '@/components/landing/About';
import Strata from '@/components/landing/Strata';
import PastProjects from '@/components/landing/PastProjects';
import Contact from '@/components/landing/Contact';
import Footer from '@/components/landing/Footer';

export default function Landing() {
  useLenis();
  const ref = useReveal();

  return (
    <div ref={ref} data-testid="landing-root" className="relative bg-bg text-ink">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: '#1A1A1A',
            color: '#F9F8F6',
            border: '1px solid #1A1A1A',
            fontFamily: 'Manrope, sans-serif',
            letterSpacing: '0.02em',
          },
        }}
      />
      <Nav />
      <main>
        <Hero />
        <PodBristol />
        <About />
        <Strata />
        <PastProjects />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
